import { networkController } from "./NetworkManager";
import { delay } from "../utils";
import type { Mutation } from "../types";

class OfflineAsyncMutationStore {
  private mutationQueue: Mutation<any>[] = [];

  public isRetrying = false;

  constructor() {
    networkController.subscribe((online) => {
      if (online) {
        this.retryMutations();
      }
    });
  }

  enqueueMutation<TMutation>(mutation: Mutation<TMutation>) {
    if (networkController.isOnline()) {
      mutation.mutate().then(mutation.resolve).catch(mutation.reject);
    } else {
      this.mutationQueue.push(mutation);
    }
  }

  private async retryMutations() {
    if (this.isRetrying) return;

    this.isRetrying = true;
    const mutationsToRetry = [...this.mutationQueue];
    this.mutationQueue = [];

    for (const mutation of mutationsToRetry) {
      try {
        const result = await mutation.mutate();
        mutation.resolve(result);
      } catch (error) {
        mutation.reject(error);
      }

      await delay(500);
    }

    this.isRetrying = false;
  }
}

export const mutationStore = new OfflineAsyncMutationStore();
